<template>
  <div>
    <el-dialog :visible.sync="consignorDialog" width="50%" title="请选择委托人">
      <el-form>
        <el-row :gutter="20" style='padding-left:30px'>
          <el-col :span="4">
            <el-form-item>
              <el-select v-model="params.column">
                <el-option
                  v-for="(item, index) in contractScreenCondition"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item>
              <el-input v-model="params.value" placeholder="请输入关键词"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item>
              <el-button @click="search" type="primary">搜索</el-button>
              <el-button @click="resetSearch" type>重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div>
        <div class="box-table" style="height:350px !important;">
          <el-table
            border
            ref="tableRef"
            :data="list"
            height="350"
            tooltip-effect="dark"
            highlight-current-row
            @current-change="handleCurrentChangeL"
            :header-cell-style="tableHeader"
            v-loading="loadingTable"
            element-loading-text="拼命加载中请稍后..."
            element-loading-spinner="el-icon-loading"
          >
            <el-table-column prop="orgName" label="部门"></el-table-column>
            <el-table-column prop="roleName" label="角色"></el-table-column>
            <el-table-column prop="staffCnName" show-overflow-tooltip label="姓名"></el-table-column>
          </el-table>
        </div>
        <div class="pagination">
          <pagination
            :total="total"
            :currentPage="currentPage"
            :pageSize="pageSize"
            @handleCurrentChange="handleCurrentChange"
            @handleSizeChange="handleSizeChange"
          ></pagination>
        </div>
        <el-form
          v-if="isShow === 'update'"
          class="demo-form-inline"
          label-width="70px"
          :rules="supplierRules"
        >
          <el-row :gutter="20" style="margin-top:20px;">
            <el-col :span="24">
              <el-form-item label="修改原因：" :rules="filter_rules({required:true})" label-width="85px">
                <el-col :span="24">
                  <el-input v-model="mark" type="textarea" :rows="5"></el-input>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onSubmit">确 定</el-button>
        <el-button @click="consignorDialog = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-------------- 二次确认 -------------->
    <open-or-close-dialog
      ref="openOrCloseRefs"
      @onUpdataState="onUpdataState"
      :title="title"
      :content="content"
    ></open-or-close-dialog>
  </div>
</template>
<script>
import pagination from '@/components/pagination'

import openOrClose from '@/components/OpenOrClose/index' // 二次确认
// import { queryAllCustomerListByClientId } from '@/api/customer/customerManage'
import { queryStaffBaseByClient } from '@/api/customer/customerManage'
export default {
  components: {
    'open-or-close-dialog': openOrClose,
    pagination
  },
  data () {
    return {
      total: 0,
      dataList: {},
      addNew: false,
      message: {},
      supplierRules: {},
      list: [],
      params: {},
      isShow: '', // 是新增还是修改
      title: '',
      mark: '',
      pageSize: 30, // 页数
      currentPage: 1, // 页码
      content: '',
      loadingTable: false,
      oldValue: '',
      consignorDialog: false,
      contractScreenCondition: [
        { label: '部门', value: 'orgName' },
        { label: '角色', value: 'roleName' },
        { label: '姓名', value: 'staffCnName' }
      ],
      withdrawalAppRuleform: {
        newValue: undefined
      }
    }
  },
  mounted () {},
  methods: {
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.getList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    },
    getList () {
      const params = {
        criteriaVoList: [this.params],
        queryPageName: ''
      }
      queryStaffBaseByClient(this.currentPage, this.pageSize, params)
        .then((res) => {
          if (res.data.code === 200) {
            this.list = res.data.obj.records
            this.total = res.data.obj.total
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 选中
    handleCurrentChangeL (val) {
      this.message = val
    },
    search () {
      if (
        this.params.value === '' ||
        this.params.value === undefined ||
        this.params.column === undefined
      ) {
        this.$message.error('搜索条件不能为空')
      } else {
        this.getList()
      }
    },
    resetSearch () {
      this.params = {}
      this.getList()
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 发货管理退货申请提醒确认
    onUpdataState () {
      if (this.isShow === 'add') {
        this.dataList.clientId = this.message.id
        this.dataList.clientName = this.message.staffCnName
        this.dataList.clientOrg = this.message.coId
        this.$emit('consignorDialog', this.dataList, 'add')
        this.consignorDialog = false
        this.params = {}
      } else {
        this.dataList.assignorNew = this.message.staffCnName
        this.dataList.assignorNewId = this.message.id
        this.dataList.assignorNewOrgId = this.message.coId
        this.dataList.mark = this.mark
        this.$emit('consignorDialog', this.dataList, 'update')
        this.consignorDialog = false
        this.params = {}
      }
    },
    onInitial (val, dataList) {
      this.dataList = {}
      this.message = {}
      this.isShow = val
      if (dataList === undefined) {
        this.addNew = true
      } else {
        this.dataList = dataList
      }
      this.consignorDialog = true
      this.getList()
    },
    onSubmit () {
      if (!this.message || !this.message.id) {
        this.$message.error('请选择委托人')
        return
      }
      if (this.isShow === 'add' && !this.addNew) {
        this.title = '新增委托人'
        this.content = '新增委托人，是否提交？'
        this.$refs.openOrCloseRefs.onInitial()
      } else if (this.isShow === 'add' && this.addNew) {
        const params = JSON.parse(JSON.stringify(this.message))
        this.dataList.clientId = params.id
        this.dataList.clientName = params.staffCnName
        this.dataList.clientOrg = params.coId
        this.$emit('consignorDialog', this.dataList)
        this.consignorDialog = false
      } else {
        if (
          this.mark === undefined ||
          this.mark === ''
        ) {
          this.$message.error('请选择委托人并填写原因!')
        } else {
          this.title = '修改委托人'
          this.content = '修改委托人需提交上级审核，确定是否提交？'
          this.$refs.openOrCloseRefs.onInitial()
        }
      }
    }
  }
}
</script>
<style>
</style>
